import type { ComponentSchema } from "../../../../../schema-types"
import { SUPPORTED_PAGES } from '../../_builder-constants'

export const schema: ComponentSchema = {
  type: 'floating-buttons',
  label: 'Floating Buttons',
  description: 'Global floating buttons for quick actions (Call, WhatsApp, Messenger).',
  supportedPages: [...SUPPORTED_PAGES],
  variants: [{ id: 'v1', label: 'Default' }],
  commonFields: [
    { key: 'active', label: 'Enable Floating Buttons', type: 'boolean', default: true },
    { key: 'phone', label: 'Phone Number', type: 'string', placeholder: '+8801...' },
    { key: 'whatsapp', label: 'WhatsApp Number', type: 'string', placeholder: '+8801...' },
    { key: 'messenger', label: 'Messenger ID/Link', type: 'string', placeholder: 'm.me/...' },
    { key: 'callUsTitle', label: 'Call Button Tooltip', type: 'string', default: 'Call Us' },
    { key: 'whatsappTitle', label: 'WhatsApp Button Tooltip', type: 'string', default: 'WhatsApp' },
    { key: 'messengerTitle', label: 'Messenger Button Tooltip', type: 'string', default: 'Messenger' },
  ],
}
